import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import Fade from '@mui/material/Fade';
import { PageWrapper, DMSALogo } from '@omnigenbiodata/ui';
import clsx from 'classnames';

import { useStyles } from './component.styles';
import { PARTNER_LOGOS } from '../../core/constants/content.constant';
import { useAuth } from '@omnigenbiodata/ui';
import PartnerLogoStrip from '../../components/content/PartnerLogoStrip';

interface MainLayoutProps {
  children: ReactNode;
  title?: string;
}

function MainLayout({ children }: MainLayoutProps) {
  const { classes } = useStyles();
  const { isAuthenticated } = useAuth();

  return (
    <>
      <PageWrapper>
        <div
          className={clsx(classes.header, {
            [classes.hasMenu]: isAuthenticated,
          })}
        >
          <Link to="/" className={classes.logo}>
            <DMSALogo size="sm" />
          </Link>
        </div>

        <Fade in timeout={500}>
          <div className={classes.content}>{children}</div>
        </Fade>
        <div className={classes.footer}>
          <PartnerLogoStrip logos={PARTNER_LOGOS} title="Study partners" />
        </div>
      </PageWrapper>
    </>
  );
}

export default MainLayout;
